import estadoSuscripciones from "../Models/EstadoSuscripciones";

export const estadosSuscripcionesMuestranDomicilioEnvio = [
    estadoSuscripciones.ACTIVA, 
    estadoSuscripciones.SUSP_VACACIONES, 
    estadoSuscripciones.PENDIENTE, 
    estadoSuscripciones.FALTA_PAGO, 
    estadoSuscripciones.BAJA_SOLICITADA,
    estadoSuscripciones.BAJA_DIFERIDA
];

export const validacionesCambioPago = [
    estadoSuscripciones.ACTIVA,
    estadoSuscripciones.PENDIENTE,
    estadoSuscripciones.SUSP_VACACIONES,
    estadoSuscripciones.FALTA_PAGO
];

export const validacionesSuspender = [
    estadoSuscripciones.ACTIVA,
    estadoSuscripciones.FALTA_PAGO,
    estadoSuscripciones.BAJA_DIFERIDA,
    estadoSuscripciones.SUSP_VACACIONES
];

export const validacionesReclamar = [
    estadoSuscripciones.ACTIVA,
    estadoSuscripciones.PENDIENTE,
    estadoSuscripciones.SUSP_VACACIONES
];

export const titulosEstados = {
    [estadoSuscripciones.ACTIVA]: "SUSCRIPCIÓN ACTIVA",
    [estadoSuscripciones.SUSP_VACACIONES]: "SUSPENDIDA POR VACACIONES",
    [estadoSuscripciones.PENDIENTE]: "PENDIENTE",
    [estadoSuscripciones.RECHAZADA]: "RECHAZADA",
    [estadoSuscripciones.BAJA]: "DADA DE BAJA",
    [estadoSuscripciones.TERMINADA]: "TERMINADA",
    [estadoSuscripciones.FALTA_PAGO]: "SUSPENDIDA POR FALTA DE PAGO",
    [estadoSuscripciones.BAJA_SOLICITADA]: "BAJA SOLICITADA",
    [estadoSuscripciones.BAJA_DIFERIDA]: "BAJA DIFERIDA",
    [estadoSuscripciones.ALTA_VENCIDA]: "ALTA VENCIDA"
};
